import { render, staticRenderFns } from "./PreHandle.vue?vue&type=template&id=53e1b677&scoped=true"
import script from "./PreHandle.vue?vue&type=script&lang=js"
export * from "./PreHandle.vue?vue&type=script&lang=js"
import style0 from "./PreHandle.vue?vue&type=style&index=0&id=53e1b677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1b677",
  null
  
)

export default component.exports